import EventCard from './eventCard/eventCard.component';
export { EventCard };
